import { useSettingVerticalizedImageryInSignUp } from "@faire/retailer-visitor-shared/settings/useSettingVerticalizedImageryInSignUp";
import { IVerticalizedImageryInSignUpXP } from "@faire/web-api--source/indigofair/data/IVerticalizedImageryInSignUpXP";

export const useIsSettingVerticalizedImageryInSignUp = () => {
  const settingVerticalizedImageryInSignUp =
    useSettingVerticalizedImageryInSignUp();

  return [
    IVerticalizedImageryInSignUpXP.Bucket.TREATMENT_A,
    IVerticalizedImageryInSignUpXP.Bucket.TREATMENT_B,
  ].includes(
    settingVerticalizedImageryInSignUp as IVerticalizedImageryInSignUpXP.Bucket
  );
};
